/// <amd-module name="Comments/Viewer/CommentViewer" />
export { CommentViewer } from "Comments/Viewer/Components/CommentViewer";
export { ICommentViewerProps } from "Comments/Viewer/Components/CommentViewer.Props";
